import NoDataPlaceholder from './NoDataPlaceholder'
import {
  Color,
  Icons,
  Paragraph
} from '@eggplant/pattern-library'

const EmptyMonitorCaseStepsInfo = () =>
  <div className='m-auto flex'>
    <NoDataPlaceholder
      icon={
        <Color
          variant='purple'
        >
          <Icons.BsSpeedometerSlow
            aria-hidden
            size='24px'
          />
        </Color>
      }
      title='No test cases step run time data available!'
    >
      <Paragraph>
        Run the selected monitor config at least once to enable test case steps performance data.<br />
        Try adjusting your filter selection..
      </Paragraph>
    </NoDataPlaceholder>
  </div>

export default EmptyMonitorCaseStepsInfo
